// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__M6OV9","topBottomGutter":"Layout_topBottomGutter__3M38D"};